import classNames from "classnames";
import dynamic from "next/dynamic";
import { CSSProperties, FC, ReactNode } from "react";
import BenefitsSection from "~/sections/BenefitsSection";
import Header from "~/sections/Header";
import HeaderV2 from "~/sections/Header/HeaderV2";

import SimpleHeader from "~/sections/Header/Simpleheader";
import { buildTree } from "~/utils/build-tree";
import { ALL_VISIBLE_THEMES, getTheme, isUsingLayoutV2 } from "~/utils/theme";
import { transformNodesToMenu } from "~/utils/transform";
import type { FooterSSR } from "~/utils/cms-blocks-ssr";
import Footer from "~/sections/Footer";
const QuickCart = dynamic(() => import("~/components/QuickCart"), {
  ssr: false,
});
const Newsletter = dynamic(
  () =>
    import(`~/theme/${getTheme()}/sections/NewsLetter`)
      .then((mod) => mod.default)
      .catch((error) => {
        return import(`~/sections/NewsLetter`).then((mod) => mod.default);
      }),
  {
    ssr: true,
    loading: () => null,
  },
);

interface LayoutProps {
  isUseLayout?: boolean;
  children?: ReactNode;
  isUseMinHeight?: boolean;
  contentContainerStyle?: CSSProperties;
  recentKeywords?: string[];
  setRecoilRecentKeyword?: (value: string[]) => void;
  className?: string;
  renderHeader?: ReactNode;
  footer?: ReactNode;
  dataMegaMenu?: any;
  storeConfig?: {
    frontend_config_logo: string;
  };
  footerSSR?: FooterSSR;
}

const Layout: FC<LayoutProps> = ({
  isUseLayout = true,
  children,
  isUseMinHeight = true,
  contentContainerStyle,
  className = "",
  renderHeader,
  footer,
  dataMegaMenu,
  storeConfig,
  footerSSR,
}) => {
  const resolvedFooter = footer ?? <Footer footerSSR={footerSSR} />;
  const menu = dataMegaMenu
    ? transformNodesToMenu(
        buildTree(dataMegaMenu?.getMenuByIdentifier?.nodes || []),
      )
    : undefined;
  if (renderHeader) {
    return (
      <div>
        {renderHeader ? renderHeader : null}

        <div
          className={classNames({ "min-h-screen": isUseMinHeight }, className)}
          style={contentContainerStyle}
        >
          {children}
        </div>
        {resolvedFooter}
      </div>
    );
  }

  if (!isUseLayout) {
    return (
      <div>
        {<SimpleHeader />}
        <div
          className={classNames({ "min-h-screen": isUseMinHeight }, className)}
          style={contentContainerStyle}
        >
          {children}
        </div>
      </div>
    );
  }

  const CustomHeader: Record<string, typeof Header> = {
    [ALL_VISIBLE_THEMES.Koarooginal]: HeaderV2,
  };

  const currentTheme = getTheme();
  const HeaderComponent = CustomHeader[currentTheme] || Header;

  return (
    <div>
      <HeaderComponent menu={menu} storeConfig={storeConfig} />
      <div
        className={classNames({ "min-h-screen": isUseMinHeight }, className)}
        style={{
          ...contentContainerStyle,
          marginBottom: isUsingLayoutV2 ? 0 : "2rem",
        }}
      >
        {children}
      </div>

      {<Newsletter />}
      <QuickCart />
      {resolvedFooter}
    </div>
  );
};

export default Layout;
